import { gql } from '@apollo/client';

export const ALL_SCHOOL_SPECIALISATION_GROUPS = gql`
  query AllSchoolSpecialisationGroups {
    schoolSpecialisationGroups: getSchoolSpecialisationGroups {
      id
      name
    }
  }
`;
